import { Slide } from 'react-awesome-reveal';
import {
  FaUser, FaMapPin, FaPhone, FaEnvelope,
  FaTwitterSquare, FaFacebookSquare, FaLinkedin, FaGithubSquare,
} from 'react-icons/fa';
import emailjs from 'emailjs-com';
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  const [notification, setNotification] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    emailjs.init('gieZnTOtTtRprHRfK');
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(e.target);

    emailjs.send(
      'service_q9j0e8e',
      'template_913tbq9',
      {
        name: formData.get('name'),
        message: formData.get('message'),
        title: formData.get('title'),
        email: formData.get('email'),
      },
    )
      .then(() => {
        setNotification({ type: 'success', message: 'Message sent successfully!' });
        setIsSubmitting(false);
      })
      .catch(() => {
        setNotification({ type: 'error', message: 'Failed to send the message. Please try again later.' });
        setIsSubmitting(false);
      });

    e.target.reset();
  };

  return (
    <Slide direction="left">
      <div className="w-screen h-screen relative z-50 pl-20 pr-36 py-20 page-layout-responsive">
        <div className="bg-slate-50 dark:bg-slate-800 w-full h-full rounded-xl p-10 overflow-y-scroll">
          <div className="mb-5">
            <p className="text-slate-500 text-lg text-center">Feel free to Contact me Anytimes</p>
            <h1 className="text-black dark:text-white font-bold text-center text-5xl my-4">
              My
              <span className="colored-main-left">Contact</span>
            </h1>
            <div className="animated-bar" />
          </div>
          {notification && (
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className={`notification ${notification.type === 'success' ? 'notification-success' : 'notification-error'} p-4 rounded-lg text-center text-white font-semibold`}
              style={{ backgroundColor: notification.type === 'success' ? 'rgb(50, 177, 248)' : '#f44336' }}
            >
              {notification.message}
            </motion.div>
          )}
          <div className="flex flex-wrap justify-between contact-small-screen">
            <div className="w-3/5 pr-5 contact-form-small">
              <h3 className="mb-6 font-semibold text-left text-2xl test-dark dark:text-white">contact me</h3>
              <form className="w-full contact-form" id="contact-form" onSubmit={sendEmail}>
                <input type="hidden" name="time" value="Mar 10 2025 08:46" />
                <div className="flex my-4">
                  <div className="w-1/2 pr-1">
                    <input className="w-full" id="contact-name" type="text" name="name" placeholder="Name" required aria-labelledby="contact-name" />
                  </div>
                  <div className="w-1/2 pl-1">
                    <input className="w-full" id="contact-email" type="email" name="email" placeholder="Email" required />
                  </div>
                </div>
                <div className="w-full my-6">
                  <input className="w-full" id="contact-subject" type="text" name="title" placeholder="Subject" required />
                </div>
                <div className="w-full my-6">
                  <textarea className="w-full" id="contact-message" name="message" placeholder="Message" rows="5" required />
                </div>
                <div className="w-full my-4 form-submit">
                  <motion.input
                    className="clickbtn button-main button-scheme"
                    id="contact-submit"
                    type="submit"
                    value={isSubmitting ? 'Sending...' : 'Send'}
                    disabled={isSubmitting}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  />
                </div>
              </form>
            </div>
            <div className="w-2/5 pl-5 contact-details-small">
              <h3 className="mb-6 font-semibold text-left text-2xl test-dark dark:text-white">Contact Info</h3>
              <p className="text-slate-500 text-lg text-left">
                Always available for freelance work if the right
                project comes along, Feel free to contact me!
              </p>
              <ul className="contact-details mt-4">
                <li className="flex py-1">
                  <div className="colored-main-left">
                    <FaUser className="mr-2" />
                  </div>
                  <div>
                    <p className="font-semibold dark:text-white">Name</p>
                    <p className="main-colored">Aime Malaika</p>
                  </div>
                </li>
                <li className="flex py-1">
                  <div className="colored-main-left">
                    <FaMapPin className="mr-2" />
                  </div>
                  <div>
                    <p className="font-semibold dark:text-white">Location</p>
                    <p className="main-colored">Kagugu, Kigali, Rwanda</p>
                  </div>
                </li>
                <li className="flex py-1">
                  <div className="colored-main-left">
                    <FaPhone className="mr-2" />
                  </div>
                  <div>
                    <p className="font-semibold dark:text-white">Call Me</p>
                    <p className="main-colored"><a href="+250787561924">+250 787 561 924</a></p>
                  </div>
                </li>
                <li className="flex py-1">
                  <div className="colored-main-left">
                    <FaEnvelope className="mr-2" />
                  </div>
                  <div>
                    <p className="font-semibold dark:text-white">Email Me</p>
                    <p className="main-colored"><a href="mailto:malaikaime@gmail.com">malaikaime@gmail.com</a></p>
                  </div>
                </li>
              </ul>
              <div className="social-icons about">
                <ul className="flex items-center mt-5">
                  <li className="pr-2.5">
                    <a className="text-slate-900 dark:text-slate-400" target="blank" href="https://twitter.com/Aime_Malaika">
                      <FaTwitterSquare />
                    </a>
                  </li>
                  <li className="px-2.5">
                    <a className="text-slate-900 dark:text-slate-400" target="blank" href="https://www.facebook.com/aime.malaikamichaelange">
                      <FaFacebookSquare />
                    </a>
                  </li>
                  <li className="px-2.5">
                    <a className="text-slate-900 dark:text-slate-400" target="blank" href="https://www.linkedin.com/in/aimemalaika">
                      <FaLinkedin />
                    </a>
                  </li>
                  <li className="px-2.5">
                    <a className="text-slate-900 dark:text-slate-400" target="blank" href="https://github.com/aimemalaika">
                      <FaGithubSquare />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Slide>
  );
};

export default Contact;
